module.exports = __webpack_public_path__ + "static/media/zip.371865d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/zip.svg
// module id = 608
// module chunks = 0